import * as React from "react";
import type { SVGProps } from "react";
const SvgStarHalf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.22 21.65a1.82 1.82 0 0 0 1.06.35 1.8 1.8 0 0 0 1.1-.33 1.72 1.72 0 0 0 .62-2l-1.81-5.19 4-2.59a1.75 1.75 0 0 0 .74-2 1.78 1.78 0 0 0-1.72-1.27h-4.65L13.69 3.2a1.79 1.79 0 0 0-3.38 0L8.44 8.62H3.79a1.78 1.78 0 0 0-1.71 1.22 1.75 1.75 0 0 0 .74 2l4 2.59-1.8 5.22a1.72 1.72 0 0 0 .62 2 1.8 1.8 0 0 0 2.14 0L12 18.58zM12 16.535a1.8 1.8 0 0 1 1.06.345l3.79 2.76-1.62-4.72a1.76 1.76 0 0 1 .71-2.05l3.48-2.25h-4a1.79 1.79 0 0 1-1.69-1.19L12 4.42z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStarHalf;
